export const loc = {
    //localStorage
    get(name = 'client_token'){
        return JSON.parse(window.localStorage.getItem(name) || '""')
    },
    set(name = 'client_token',data){
        window.localStorage.setItem(name,JSON.stringify(data))
    },
    remove(name = 'client_token'){
        window.localStorage.removeItem(name)
    },
    clear(){
        window.localStorage.clear()
    }
    
}

export const sen = {
    //sessionStorage
    get(name){
       return JSON.parse(window.sessionStorage.getItem(name) || '""')
    },
    set(name,data){
        window.sessionStorage.setItem(name,JSON.stringify(data))
    },
    remove(name){
        window.sessionStorage.removeItem(name)
    },
    clear(){
        window.sessionStorage.clear()
    }
}


// WEBPACK FOOTER //
// ./src/axios/storage.js